import { UnitOperation } from '../../unit-operation';
import { unitOperationsConfig } from '../../../_config/unit-operations.config';
import { Case } from '../../case';

export class WaterUtilityUnitOperation extends UnitOperation {
  category = unitOperationsConfig.waterUtilityUnitOperation.key;
  isSolved: boolean;

  constructor(unitOperation: WaterUtilityUnitOperation | any, ownerCase: Case) {
    super(unitOperation, ownerCase);
    this.initValues(unitOperation);
  }

  override initValues(unitOperation: any) {
    this.isSolved = unitOperation.isSolved;
  }

  override clearResults() {
    super.clearResults();
    this.isSolved = false;
  }

  override setSimulationVariableNames() {}

  override get isFlowsheetOwner() {
    return true;
  }
}
